const NS = 'TagListFilter';

export default function TagListFilter() {
  return tags => {
    if (!tags || !tags.length) {
      return '';
    }
    return tags.map(t => t.name).join(', ');
  };
}
